export const CHAT_SCROLL_THRESHOLD = 500;

export const PARTICIPANT_JOINED = 'PARTICIPANT_JOINED';
export const PARTICIPANT_HUNG_UP = 'PARTICIPANT_HUNG_UP';
export const WAITING_FOR_CONNECTION = 'WAITING_FOR_CONNECTION';
export const DISCONNECTED = 'DISCONNECTED';
export const WAITING_FOR_ANSWERING = 'WAITING_FOR_ANSWERING';
